import { ThemeProvider, createTheme } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MapComponent from "./Components/MapComponentV2";
import NetworkComparisonDashboard from "./Components/NetworkComparisonDashboard";
import CostComparisonDashboard from "./Components/CostComparisonDashboard";
import { useAuth } from "react-oidc-context";
import { useEffect } from "react";

function App() {
    // Create a light theme
    const theme = createTheme({
        palette: {
            mode: "light",
            primary: {
                main: "#1976d2",
            },
            background: {
                default: "#f5f5f5",
            },
        },
    });

    const auth = useAuth();

    if (auth.isLoading) {
        return <div>Loading...</div>;
    }

    if (auth.error) {
        return <div>Encountering error... {auth.error.message}</div>;
    }

    if (auth.isAuthenticated) {
        const url = new URL(window.location.href);
        url.searchParams.delete("code");
        url.searchParams.delete("state");
        window.history.replaceState({}, document.title, url.toString());
        return (
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <BrowserRouter>
                    <Box
                        sx={{
                            height: "100vh",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        <Routes>
                            <Route path="/" element={<MapComponent />} />
                            <Route
                                path="/network-comparison"
                                element={<NetworkComparisonDashboard />}
                            />
                            <Route
                                path="/cost-comparison"
                                element={<CostComparisonDashboard />}
                            />
                        </Routes>
                    </Box>
                </BrowserRouter>
            </ThemeProvider>
        );
    }

    return <SignInPage />;
}

const SignInPage = () => {
    const auth = useAuth();
    useEffect(() => {
        const timer = setTimeout(() => {
            auth.signinRedirect();
        }, 500);
        return () => clearTimeout(timer);
    }, []);

    return null;
};

export default App;
